import $http from '../../shared/http';

export default {
  namespaced: true,
  state: () => {
    return {
      currentFinancialBudget: null,
      financialBudgetsForSelect: [],
      ministryFinancialBudgets: [],
    };
  },
  getters: {
    getCurrentFinancialBudget: (state) => state.currentFinancialBudget,
    getFinancialBudgetsForSelect: (state) => state.financialBudgetsForSelect,
    getMinistryFinancialBudgets: (state) => state.ministryFinancialBudgets,
    getMinistryFinancialBudgetsForSelect: (state) =>
      state.ministryFinancialBudgets?.map((b) => {
        const isSupplementaryBudget = b.is_supplementary_budget;
        const period = b.period.financial_year;
        const ministry = b.originatingMinistry.name;
        const budgetName = `${period} ${
          isSupplementaryBudget ? 'Supplementary' : 'Primary'
        } Budget for ${ministry}`;

        return { text: budgetName, value: b.id };
      }),
  },
  mutations: {
    setCurrentFinancialBudget: (state, payload) => (state.currentFinancialBudget = payload),
    setFinancialBudgetsForSelect: (state, payload) => (state.financialBudgetsForSelect = payload),
    setMinistryFinancialBudgets: (state, payload) => (state.ministryFinancialBudgets = payload),
  },
  actions: {
    async CREATE_FINANCIAL_BUDGET(ctx, form) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post('financial-budgets', form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then((response) => {
            return resolve(response.data.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async EDIT_FINANCIAL_BUDGET(ctx, { form, id }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .put(`financial-budgets/${id}`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then((response) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async DELETE_FINANCIAL_BUDGET(ctx, { id }) {
      return $http()
        .delete(`financial-budgets/${id}`, { notifiable: true })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    async LOAD_FINANCIAL_BUDGET({ commit }, id) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`financial-budgets/${id}`)
          .then((response) => {
            commit('setCurrentFinancialBudget', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    async LOAD_FINANCIAL_BUDGET_ITEMS_FOR_SELECT(_, { budgetId, churchId }) {
      return $http('v2')
        .get(`organisations/${churchId}/financial_budgets/${budgetId}/items/select`)
        .then((response) => {
          return response.data.data;
        });
    },
    async LOAD_MINISTRY_FINANCIAL_BUDGETS({ commit }, { ministry_id, financial_period_id }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/ministry-periodic-financial-budgets/${ministry_id}/${financial_period_id}`)
          .then((response) => {
            commit('setMinistryFinancialBudgets', response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
